import React, { useEffect } from "react";
import xls from "xlsx";
import { useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { Container, Row, Col } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { JsonToTable } from "react-json-to-table";
import { Modal } from "react-bootstrap";
import moment from "moment";
import * as fs from "fs";
import { uploadTransaction } from "../../stores/services/beta-transaction.service";
import {
  addDailyNav,
  addDailyNavBulkUploader,
  getDailyNavOfAllFunds,
  getFundByAmc,
} from "../../stores/services/funds.service";
import { getAccountByFund } from "../../stores/services/account.service";
import { env } from "../../env";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../utils/customFunction";
import OTPComponent from "../dividend/otp-modal";

let csvToJson = require("convert-csv-to-json");
const csv = require("csvtojson/v2");

let xlsxToJson = require("convert-excel-to-json");

const LegacyNavsUploader = () => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const arrHeader = [
    "FundCode",
    "NAVDate",
    "TotalNetAssets",
    "TotalFundUnitsIssued",
    "DailyNAV",
    "OfferPrice",
    "RedemptionPrice",
  ];

  const requiredNAVData = ["FundCode", "NAVDate", "DailyNAV"];

  const history = useHistory();
  const [errorBoolean, setErrorBoolean] = useState(false);
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
  const [loading, setLoading] = useState(false);
  const [fileData, setfileData] = useState<any>([]);
  const [fileDataCount, setFileDataCount] = useState(0);
  const myRef1 = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState("");
  const [file, setFile] = useState<any>();
  const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
  const email = sessionStorage.getItem("email") || "";
  const [errorInFile, setErrorInFile] = useState(false);
  const [allAvailableFunds, setAllAvailableFunds] = useState<any>([]);
  const [loadingFileUpload, setLoadingFileUpload] = useState(false);
  const [otpFlag, setOtpFlag] = useState(false);
  const [previousNavModal, setPreviousNavModal] = useState(false);
  const [isValidate, setIsValidate] = useState(true);
  const [previousNavData, setPreviousNavData] = useState<any>([]);
  const [bulkNavData, setBulkNavData] = useState<any>([]);

  useEffect(() => {
    const allFunds = async () => {
      try {
        let res = await getFundByAmc(email, amcCode);
        if (res?.status === 200 && res?.data?.status === 200) {
          const temp = res?.data?.data?.map((item) => `${item?.symbol_code}`);
          setAllAvailableFunds(temp);
        }
      } catch (error) {
        console.log("error", error);
      }
    };
    allFunds();
  }, []);

  const upload = async (e: any) => {
    if (e?.target.files[0] && e.target.value) {
      setIsValidate(true);
      setFileError("");
      setfileData(null);
      let file = e?.target.files[0];

      let type = file?.name?.substring(file?.name?.lastIndexOf(".") + 1);
      if (type === "xlsx" || type === "csv") {
        setFile(file);
        setFileName(file?.name);

        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = async (e) => {
          const bstr = e.target?.result;
          const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data: any = xls.utils.sheet_to_json(ws, {
            header: 2,
            raw: false,
            defval: "",
            dateNF: "YYYY-MM-DD",
          });

          const resetAndInvalidate = (message: string) => {
            toast.error(message);
            setfileData([]);
            setFileDataCount(0);
            setFileName("");
            setIsValidate(false);
          };

          const checkRequiredFields = (data, requiredFields) => {
            return data.some((row) => {
              return requiredFields.some((field) => {
                const value = row[field.trim()]?.toString().trim(); // get trim valu
                return !value; // true if valu is emoty
              });
            });
          };

          if (data?.length === 0) {
            resetAndInvalidate("File Should not be empty");
            return;
          }

          const uploadedHeaders = Object.keys(data[0])
            ?.filter((ele) => !ele?.includes("__EMPTY"))
            .map((item) => item.trim()?.toLowerCase());

          const headersMatch =
            uploadedHeaders?.length > arrHeader?.length
              ? uploadedHeaders?.every((header) => {
                  return arrHeader.includes(header.trim()?.toLowerCase());
                })
              : arrHeader?.every((header) => {
                  return uploadedHeaders.includes(header.trim()?.toLowerCase());
                });
          if (!headersMatch) {
            resetAndInvalidate(
              "Uploaded file headers do not match the expected format."
            );
            return;
          }

          if (
            data.some(
              (ele) =>
                !allAvailableFunds?.includes(
                  ele?.FundCode?.toUpperCase()?.trim()
                )
            )
          ) {
            const indexOfErr = data?.findIndex(
              (item) =>
                !allAvailableFunds?.includes(
                  item?.FundCode?.toUpperCase()?.trim()
                )
            );
            resetAndInvalidate(
              `Invalid fund code. Please enter a valid fund for row ${
                indexOfErr + 2
              }`
            );
            return;
          }

          if (data?.some((ele) => ele?.NAVDate?.trim() == "")) {
            const indexOfErr = data?.findIndex(
              (item) => item?.NAVDate?.trim() == ""
            );
            resetAndInvalidate(
              `Nav Date should not be empty for row ${indexOfErr + 2}`
            );
            return;
          }

          if (data?.some((ele) => ele?.DailyNAV?.trim() == "")) {
            const indexOfErr = data?.findIndex(
              (item) => item?.DailyNAV?.trim() == ""
            );
            resetAndInvalidate(
              `DailyNAV should not be empty for row ${indexOfErr + 2}`
            );
            return;
          }

          if (!data?.every((ele) => ele?.FundCode == data[0]?.FundCode)) {
            resetAndInvalidate(`The file should contain only one fund.`);
            return;
          }

          const numericFields = [
            "TotalNetAssets",
            "TotalFundUnitsIssued",
            "DailyNAV",
            "OfferPrice",
            "RedemptionPrice",
          ];

          for (let i = 0; i < data.length; i++) {
            const row = data[i];
            for (const field of numericFields) {
              const value = row[field];
              if (value !== "" && isNaN(Number(value))) {
                resetAndInvalidate(
                  `Row ${i + 2}: '${field}' must be a number.`
                );
                return;
              }
            }
          }

          let DatePrevious = new Date(data[0].NAVDate);
          DatePrevious.setDate(DatePrevious.getDate() - 1);

          try {
            let temp: any = [];
            const response = await getDailyNavOfAllFunds(
              email,
              amcCode,
              DatePrevious?.toString()
            );
            let fooArray = Object.entries(response.data);
            fooArray.forEach(([key, value]) => {
              temp.push(value);
            });
            temp = temp?.filter((ele1) => ele1?.fund == data[0]?.FundCode);

            if (
              temp[0]?.nav == 0 &&
              temp[0]?.redemption_price == 0 &&
              temp[0]?.total_fund_units == 0 &&
              temp[0]?.total_net_asset == 0
            ) {
              resetAndInvalidate(`Previous nav doesn't exist`);
              return;
            } else {
              for (let i = 1; i < data?.length; i++) {
                const currentNavDate = moment(data[i]?.NAVDate);
                const previousNavDate = moment(data[i - 1]?.NAVDate);
                const expectedNextDate = previousNavDate.add(1, "days");
                if (!currentNavDate.isSame(expectedNextDate, "day")) {
                  resetAndInvalidate(
                    `Date sequence broken at row ${
                      i + 2
                    }. Expected ${expectedNextDate.format(
                      "M/D/YY"
                    )}, but found ${currentNavDate.format("M/D/YY")}.`
                  );
                  return;
                }
              }
            }
          } catch (err: any) {
            if (err.response !== undefined) {
              resetAndInvalidate(err.response.data.message);
            } else {
              resetAndInvalidate("Request Failed!");
            }
            return;
          }

          const hasEmptyAccountsFields = checkRequiredFields(
            data,
            requiredNAVData
          );

          if (hasEmptyAccountsFields) {
            setErrorInFile(true);
          } else {
            setErrorInFile(false);
          }

          if (data.length > 0) {
            // console.log("inside, isValidate should be true:", isValidate);
            let temp: any = [];
            const filteredData = data.map((obj) => {
              return Object.fromEntries(
                Object.entries(obj).filter(
                  ([key]) => !key.startsWith("__EMPTY")
                )
              );
            });
            temp = filteredData?.map((ele) => {
              return {
                amc_code: amcCode,
                calculated_nav_data: "",
                fund: ele?.FundCode?.trim(),
                nav: ele?.DailyNAV?.trim(),
                nav_date: ele?.NAVDate?.trim(),
                offer_price: ele?.OfferPrice?.trim(),
                offer_rate: "sale",
                redemption_price: ele?.RedemptionPrice?.trim(),
                total_fund_units: ele?.TotalFundUnitsIssued?.trim(),
                total_net_asset: ele?.TotalNetAssets?.trim(),
              };
            });
            setBulkNavData(temp);
            setfileData(filteredData);
            setFileDataCount(data.length);
          }
        };
        if (rABS) reader.readAsBinaryString(file);
        else reader.readAsArrayBuffer(file);
      } else {
        toast.error("Please Upload Correct Format of File");
        setfileData([]);
        setFileDataCount(0);
        setFileName("");
        setIsValidate(false);
      }
      e.target.value = "";
    }
  };

  const renderTable = () => {
    return fileData?.map((item: any, index: number) => {
      return (
        <tr key={index}>
          {Object.entries(item).map(([key, value]: [string, any]) => {
            let isHighlighted = false;

            if (requiredNAVData?.includes(key) && value?.trim() === "") {
              isHighlighted = true;
            }
            return (
              <td
                key={key}
                style={{
                  backgroundColor: isHighlighted ? "#8b0000" : "",
                  border: "1px solid #525f7f",
                }}
              >
                {Number(Number(value))
                  ? numberWithCommas(
                      value?.split(".")?.length > 1
                        ? Number(value)?.toFixed(4)
                        : Number(value)
                    )
                  : key == "NAVDate"
                  ? moment(value).format("M/D/YYYY")
                  : value}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  const handleUploadFiles = async () => {
    setLoadingFileUpload(true);
    if (errorInFile === true) {
      toast.error("First fill the required fields");
      setLoadingFileUpload(false);
      return;
    }
    try {
      const response = await addDailyNavBulkUploader(email, bulkNavData);
      if (response.data.status == 200) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error: any) {
      if (error.response != undefined) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    } finally {
      setLoadingFileUpload(false);
      setBulkNavData([]);
      setErrorInFile(false);
      setfileData([]);
      setFileDataCount(0);
      setFileName("");
    }
  };

  return (
    <>
      <div className="content">
        {/* --------- Modal for Previous Nav Data Start------------- */}
        <Modal
          className=""
          dialogClassName="modal90w"
          show={previousNavModal ? true : false}
          size="lg"
          backdrop={true}
          onHide={() => {
            setPreviousNavModal(false);
          }}
          centered={true}
        >
          <div className="modal-header mb-3">
            <div className="flex justify-content-between align-items-center">
              <h1>Previous NAV data for the following funds is missing</h1>
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setPreviousNavModal(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
            </div>
          </div>
          <div className="modal-body pt-2">
            <div
              style={{
                maxHeight: "400px",
              }}
              className="table-responsive"
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>SR</th>
                    <th className="text-left">Fund Code</th>
                  </tr>
                </thead>
                <tbody>
                  {previousNavData.length > 0
                    ? previousNavData?.map((item: any, index: number) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="text-left">{item?.fund}</td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
        {/* --------- Modal for Previous Nav Data End------------- */}

        {/* ------------ Modal for OTP verification Start --------------- */}
        <Modal
          className="otp-verification-modal"
          dialogClassName="modal-lg"
          show={otpFlag}
          backdrop={otpFlag}
          keyboard={false}
          centered
          onHide={() => {
            setOtpFlag(false);
          }}
        >
          <div className="modal-header border-0 pb-0">
            <div className="w-100 text-center">
              <h5 className="modal-title fw-bold text-primary mb-2">
                Upload Bulk Nav Data
              </h5>
              <p className="text-muted mb-0">
                Please verify through OTP to process the bulk upload
              </p>
            </div>
            <button
              type="button"
              className="btn-close bg-transparent text-light border-0"
              aria-label="Close"
              onClick={() => {
                setOtpFlag(false);
              }}
            >
              x
            </button>
          </div>

          <div className="modal-body px-4 py-3">
            <OTPComponent
              body={{ email, amc_code: amcCode }}
              onSuccess={async () => {
                await handleUploadFiles();
                setOtpFlag(false);
              }}
            />
          </div>
        </Modal>
        {/* ------------ Modal for OTP verification End --------------- */}

        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="card">
                <div className="">
                  <div className="card-header">
                    <h4 className="card-title">
                      Legacy Nav Bulk Upload
                      <Dropdown className="float-right">
                        <Dropdown.Toggle
                          href={`${env.REACT_APP_SAMPLE_URL}NAV.xlsx`}
                          variant="dark"
                          id="dropdown-basic"
                        >
                          Download Sample
                        </Dropdown.Toggle>
                      </Dropdown>
                    </h4>
                  </div>
                  <div className="card-body">
                    <Row className="mb-3">
                      <Col md="6">
                        <label>Choose File </label>
                        <div
                          className="form-control multi-input ml-auto"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => myRef1?.current?.click()}
                        >
                          <div className="form-group mb-0">
                            <div className="fom-control ml-2">
                              {fileName === "" ? "Upload File" : fileName}
                            </div>
                            <input
                              className="form-control"
                              type="file"
                              ref={myRef1}
                              style={{ display: "none" }}
                              multiple={false}
                              onChange={(e) => {
                                upload(e);
                              }}
                            />
                            {fileError ? (
                              <p className="error-labels error-message2">
                                {fileError}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        {fileUploadingFlag && (
                          <img src="assets/loader.svg" width="50" />
                        )}
                      </Col>
                    </Row>
                    {fileData?.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table mt-3 ">
                          <thead>
                            {Object.keys(fileData?.[0])?.map((heading) => {
                              return (
                                <th
                                  style={{
                                    paddingLeft: "7px",
                                    paddingRight: "7px",
                                    border: "1px solid",
                                  }}
                                  className="text-nowrap"
                                >
                                  {heading}
                                </th>
                              );
                            })}
                          </thead>
                          <tbody>{renderTable()}</tbody>
                        </table>
                      </div>
                    ) : fileName ? (
                      <Row className="d-flex justify-content-center my-3">
                        <i
                          className="fa fa-spinner fa-spin fa-3x"
                          aria-hidden="true"
                        ></i>
                      </Row>
                    ) : null}
                    Total Rows:{" "}
                    <span className="text-primary mt-3">{fileDataCount} </span>
                    <div className="mt-4">
                      <button
                        className="btn btn-primary"
                        disabled={
                          Boolean(loading) ||
                          fileData?.length < 1 ||
                          loadingFileUpload
                        }
                        onClick={() => setOtpFlag(true)}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Upload</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default LegacyNavsUploader;
